// import { authHeader } from '../_helpers';
import data from '../lib/backend/data'

export const userService = {
    login,
    logout
};

function login( username, password ) {
    return fetch(`${data.urlapi}/api/usuarios/login`, {
        method: 'POST',
        body: JSON.stringify({
            email: username.toLowerCase(),
            password: password
        }),
        headers: {
        'Content-Type':'application/json'
        }
    })
        .then(user => user.json())
        .then(user => {         
            if (user) {
                user.authdata = window.btoa(username + ':' + password);
                localStorage.setItem('bumer_bknd_user', JSON.stringify(user));
                return user;
            }
            return false;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('bumer_bknd_user');
}
